/* Goloka V3 — in-place hover zoom on the product gallery (client, 10 Oct 2026).
   Desktop with a fine pointer only. The photo scales 2.2x and pans with the
   cursor; on first hover it asks for a 2000px source so the zoom stays sharp.
   Click still opens the lightbox (Dawn product-modal). */
(function () {
  if (!matchMedia('(hover: hover) and (pointer: fine)').matches) return;
  if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  function bind(root) {
    root.querySelectorAll('.product__media-list .product__media-item .product-media-container').forEach(function (box) {
      if (box.dataset.v3Zoom) return;
      var img = box.querySelector('img.image-magnify-lightbox, img.image-magnify-hover, .product__media img');
      if (!img) return;
      box.dataset.v3Zoom = '1';
      box.classList.add('v3-zoomable');
      box.addEventListener('mouseenter', function () {
        if (!img.dataset.v3Hi) { img.sizes = '2000px'; img.dataset.v3Hi = '1'; }
        box.classList.add('is-zoomed');
      });
      box.addEventListener('mousemove', function (e) {
        var r = box.getBoundingClientRect();
        img.style.transformOrigin = ((e.clientX - r.left) / r.width * 100) + '% ' + ((e.clientY - r.top) / r.height * 100) + '%';
      });
      box.addEventListener('mouseleave', function () { box.classList.remove('is-zoomed'); img.style.transformOrigin = ''; });
    });
  }
  function boot() { bind(document); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) { bind(e.target); });
})();
